import { API } from '../../Config'
import { API_GET } from '../../Config'

export const GetVoucher = () => {
  return (
    API_GET(API.GetVoucher)
  )
}

